import React, { useState } from "react";
import InputField from "common/customInputField";
import SelectInput from "common/selectInput";
import Button from "react-bootstrap/Button";
import { useCookies } from "react-cookie";
import { useSearchParams } from "react-router-dom";
import _ from "lodash";

const CookieForm = () => {
  const [, setCookie] = useCookies([window.env?.REACT_APP_LOGIN_COOKIE ?? "sl2sta_dev"]);
  const [params] = useSearchParams();
  const [state, setState] = useState({
    email: "",
    sub: "",
    personID: "",
    firstName: "",
    lastName: "",
    fcRole: "",
    district: "",
    storeCcn: "",
    terrCcn: "",
  });

  const handleChange = (e, selectValue) => {
    const { id, value } = e.target;
    setState({ ...state, [id]: id === "fcRole" ? selectValue.id : value });
  };

  const quickSelectRoles = [
    {
      fcRole: "FcDistrictMgr",
      email: "john.cunningham@sherwin.com",
      sub: "jcc01r",
      personID: "262875",
      firstName: "John",
      lastName: "Cunningham",
      district: "3530",
      storeCcn: "709989",
      terrCcn: "800100",
    },
    {
      fcRole: "FcStoreManager",
      email: "sw725229@sherwin.com",
      sub: "jgm548",
      personID: "282688",
      firstName: "John",
      lastName: "Mcmorris",
      district: "3530",
      storeCcn: "725229",
      terrCcn: "800100",
    },
    {
      fcRole: "FcOpsMgr",
      email: "sw725229@sherwin.com",
      sub: "mps970",
      personID: "277892",
      firstName: "Melton",
      lastName: "Snipes",
      district: "3530",
      storeCcn: "725229",
      terrCcn: "800100",
    },
    {
      fcRole: "FcCityMgr",
      email: "richard.m.shields@sherwin.com",
      sub: "rms918",
      personID: "251582",
      firstName: "Richard",
      lastName: "Shields",
      district: "3530",
      storeCcn: "709989",
      terrCcn: "800100",
    },
    {
      fcRole: "FcSalesRep",
      email: "wesley.d.odum@sherwin.com",
      sub: "wdo197",
      personID: "285739",
      firstName: "Wesley",
      lastName: "Odum",
      district: "3530",
      storeCcn: "725229",
      terrCcn: "756971",
    },
  ];

  return (
    <>
      <div className="container-fluid search-form-container">
        <div className="search-form-container__title d-flex justify-content-between align-items-center flex-column flex-md-row align-items-md-center">
          <span className="search-form-container__title--text mb-4 mb-md-0">Role Presets:</span>
          <div>
            {quickSelectRoles.map((user) => (
              <Button key={user.fcRole} variant="outline-primary" onClick={() => setState(user)}>
                {user.fcRole}
              </Button>
            ))}
          </div>
        </div>
        <div className="search-form-container__fields">
          <form className="search-form-container__fields__form">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-6 col-lg-4 search-form-container__fields__form-group">
                <InputField
                  type="text"
                  label="Email"
                  id="email"
                  placeholder="Enter email"
                  fieldClasses="form-control search-form-container__fields__form-group__item"
                  value={state.email}
                  onChange={handleChange}
                  disabled={false}
                  isRequired={false}
                />
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-4 search-form-container__fields__form-group">
                <InputField
                  type="text"
                  label="Sherwin ID"
                  id="sub"
                  placeholder="Enter Sherwin ID"
                  fieldClasses="form-control search-form-container__fields__form-group__item"
                  value={state.sub}
                  onChange={handleChange}
                  disabled={false}
                  isRequired={false}
                />
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-4 search-form-container__fields__form-group">
                <InputField
                  type="text"
                  label="Person ID"
                  id="personID"
                  placeholder="Enter Person ID"
                  fieldClasses="form-control search-form-container__fields__form-group__item"
                  value={state.personID}
                  onChange={handleChange}
                  disabled={false}
                  isRequired={false}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-sm-12 col-md-6 col-lg-4 search-form-container__fields__form-group">
                <InputField
                  type="text"
                  label="First Name"
                  id="firstName"
                  placeholder="Enter first name"
                  fieldClasses="form-control search-form-container__fields__form-group__item"
                  value={state.firstName}
                  onChange={handleChange}
                  disabled={false}
                  isRequired={false}
                />
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-4 search-form-container__fields__form-group">
                <InputField
                  type="text"
                  label="Last Name"
                  id="lastName"
                  placeholder="Enter last name"
                  fieldClasses="form-control search-form-container__fields__form-group__item"
                  value={state.lastName}
                  onChange={handleChange}
                  disabled={false}
                  isRequired={false}
                />
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-4 search-form-container__fields__form-group">
                <SelectInput
                  options={[
                    "FcVPS",
                    "FcSuperAdmin",
                    "FcAdmin",
                    "FcDistrictMgr",
                    "FcCityMgr",
                    "FcStoreManager",
                    "FcOpsMgr",
                    "FcEstimator",
                    "FcSalesRep",
                    "FcOtherEE",
                    "FcTechRep",
                    "FcNA",
                  ].map((item) => ({ id: item, description: item }))}
                  label="FC Role"
                  defaultValue="Select Role"
                  id="fcRole"
                  value={state.fcRole}
                  handleSelectInput={handleChange}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-sm-12 col-md-6 col-lg-4 search-form-container__fields__form-group">
                <InputField
                  type="text"
                  label="District"
                  id="district"
                  placeholder="Enter District"
                  fieldClasses="form-control search-form-container__fields__form-group__item"
                  value={state.district}
                  onChange={handleChange}
                  disabled={false}
                  isRequired={false}
                />
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-4 search-form-container__fields__form-group">
                <InputField
                  type="text"
                  label="Store Number"
                  id="storeCcn"
                  placeholder="Enter Store Number"
                  fieldClasses="form-control search-form-container__fields__form-group__item"
                  value={state.storeCcn}
                  onChange={handleChange}
                  disabled={false}
                  isRequired={false}
                />
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-4 search-form-container__fields__form-group">
                <InputField
                  type="text"
                  label="Territory Number"
                  id="terrCcn"
                  placeholder="Enter Territory Number"
                  fieldClasses="form-control search-form-container__fields__form-group__item"
                  value={state.terrCcn}
                  onChange={handleChange}
                  disabled={false}
                  isRequired={false}
                />
              </div>
            </div>
          </form>
        </div>
        <div className="d-flex search-form-container__fields__btn">
          <Button
            variant="outline-primary"
            disabled={_.some(state, _.isEmpty)}
            onClick={() => {
              const header = { alg: "RS256" };
              const claims = {
                aud: "sherwin.com",
                sub: state.sub,
                personID: state.personID,
                firstname: state.firstName,
                lastname: state.lastName,
                email: state.email,
                district: state.district,
                storeCcn: state.storeCcn,
                terrCcn: state.terrCcn,
                fcRole: state.fcRole,
                iss: "dev-sherlink.sherwin.com",
              };
              const cookieVal = `${btoa(JSON.stringify(header))}.${btoa(JSON.stringify(claims))}`;
              setCookie(window.env?.REACT_APP_LOGIN_COOKIE ?? "sl2sta_dev", cookieVal);
              window.location.assign(params.get("forwardURL") ?? "/");
            }}
          >
            Generate Cookie
          </Button>
        </div>
      </div>
    </>
  );
};

export default CookieForm;
